'use client'

import React from 'react'
import { Button } from "@/components/ui/button"
import Header from './Header'
import Footer from './Footer'




export function FarminstaIntroLayout({ children ,currentPage,isBookADemo=true}) {
  return (
    <div className="min-h-screen bg-white">
      <Header currentPage={currentPage} />
      {/* <HeroSection />
      <LogoSection />
      <FeaturesSection />
      <OperationsSection />
      <BrandVisibilitySection />
      <CampaignHubSection />

      <TestimonialsSection />
      <StatsSection /> */}
      {children}
      <Footer isBookADemo={isBookADemo} />
    </div>
  )
}